function venue_single_init() {
    if( ! document.querySelectorAll('body.single-venue').length )
        return;

    // price formatting
    document.querySelectorAll('.pkg .price', ).forEach(element => {
        let content = element.innerHTML;
            
        content = content.replace('.00', '');

        if( content.includes('.') ) {
            let content_components = content.split('.');
            content = content_components[0] + '<span>.' + content_components[1] + '</span>';
        }

        element.innerHTML = content;
    
    });
}

jQuery(document).ready(function() {
    venue_single_init();
});